import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
interface PdfCredentialDetailsProps {
  data: any;
}

export const PdfCredentialDetails: React.FC<PdfCredentialDetailsProps> = (props) => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '9px',
      paddingBottom: '10px'
    },
    leftColumn: {
      flexDirection: 'row'
    },
    row: {
      width: '100%'
    },
    bannertext: {
      fontSize: '14px',
      backgroundColor: '#ebf9fb',
      marginBottom: '7px',
      color: '#298d9c',
      padding: '2.5px 2.5px 2.5px 5px',
      fontFamily: 'Libre Franklin Bold',
      borderBottom: '1px solid #288C9C',
      borderTop: '1px solid #288C9C'
    },
    container: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      fontFamily: 'Libre Franklin',
      paddingBottom: 8,
      width: '500px'
    },
    label: {
      fontSize: '10px',
      width: '115px',
      fontFamily: 'Libre Franklin Bold',
    },
    labelValue: {
      fontSize: '9px',
      width: '385px'
    }
  });

  return (
    <View style={styles.leftColumn}>
      <View style={styles.row}>
        <Text style={styles.bannertext}>Credential Details </Text>
        <View style={{ paddingBottom: 5 }}>
          <View style={styles.container}>
            <Text style={styles.label}>Name on Document: </Text>
            <Text style={styles.labelValue}>{props.data.nameOnCredential}</Text>
          </View>

          <View style={styles.container}>
            <Text style={styles.label}>Type of Credential: </Text>
            <Text style={styles.labelValue}>
              {props.data.credentialType === 'primary'
                ? 'Primary Professional Education Credential'
                : props.data.credentialType === 'other'
                ? 'Other Credential'
                : props.data.credentialType}
            </Text>
          </View>

          <View style={styles.container}>
            <Text style={styles.label}>Status of Credential: </Text>
            <Text style={[{ fontFamily: 'Libre Franklin Bold', color: '#298d9c', fontSize: 10.5 }]}>
              {props.data.statusOfCredential
                ? props.data.statusOfCredential !== 'verificationAccepted'
                  ? props.data.statusOfCredential
                      ?.replace(/\B([A-Z])/g, ' $1')
                      .replace(/\bVerified\b(?!\s*-\s*)/g, 'Verified -')
                      .replace(/-\s+/g, '- ')
                      .replace(/^./, (c: string) => c.toUpperCase())
                      .replace('To', 'to')
                  : 'VERIFIED'
                : ''}
            </Text>
          </View>

          <View style={{ flexDirection: 'row', fontFamily: 'Libre Franklin', paddingBottom: 8 }}>
            <Text style={styles.label}>Issuing Institution: </Text>
            <Text style={{ ...styles.labelValue, width: '75%' }}>{props.data.issuingInstitution}</Text>
          </View>
        </View>
      </View>
    </View>
  );
};
export default PdfCredentialDetails;
